import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TechRoleService } from "../../../services/TechRoleService";
import TechByTechRoleHeader from "./TechByTechRoleHeader";
import { TechByTechRoleService } from "../../../services/TechByTechRoleService";
import TechByTechRoleItemGroup from "./TechByRoleItemGroup";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import { translateAndSortAscendant } from "../../../common/helper";
export default function TechByTechRolePage() {
  const { t } = useTranslation();
  const [techRoles, setTechRoles] = useState([]);
  const [selectedTechRole, setSelectedTechRole] = useState({});
  const [techByTechRole1, setTechByTechRole1] = useState([]);
  const [techByTechRole2, setTechByTechRole2] = useState([]);
  const [techByTechRole3, setTechByTechRole3] = useState([]);
  const [techByTechRole4, setTechByTechRole4] = useState([]);
  const [techByTechRole5, setTechByTechRole5] = useState([]);
  const [techByTechRole6, setTechByTechRole6] = useState([]);
  const [selectedTechByTechRole, setSelectedTechByTechRole] = useState([]);

  function onChangeTechrole({ target }) {
    setSelectedTechRole(techRoles.find((x) => x.id === parseInt(target.value)));
  }
  function submit() {
    let _selectedTechByTechRole = [];
    _selectedTechByTechRole = selectedTechByTechRole.map((x) => x.id);
    TechByTechRoleService.createOrUpdate(
      selectedTechRole.id,
      _selectedTechByTechRole
    ).then((data) => {
      setSelectedTechByTechRole([]);
    });
  }

  useEffect(() => {
    getTechRoles();
  }, []);

  function cormfimSave() {
    let _selectedTechByTechRole = [];

    _selectedTechByTechRole = _selectedTechByTechRole.concat(
      techByTechRole1.filter((x) => x.selected)
    );

    _selectedTechByTechRole = _selectedTechByTechRole.concat(
      techByTechRole2.filter((x) => x.selected)
    );

    _selectedTechByTechRole = _selectedTechByTechRole.concat(
      techByTechRole3.filter((x) => x.selected)
    );

    _selectedTechByTechRole = _selectedTechByTechRole.concat(
      techByTechRole4.filter((x) => x.selected)
    );

    _selectedTechByTechRole = _selectedTechByTechRole.concat(
      techByTechRole5.filter((x) => x.selected)
    );
    _selectedTechByTechRole = _selectedTechByTechRole.concat(
      techByTechRole6.filter((x) => x.selected)
    );
    _selectedTechByTechRole = translateAndSortAscendant(
      _selectedTechByTechRole,
      "description"
    );
    setSelectedTechByTechRole(_selectedTechByTechRole);
  }

  useEffect(() => {
    if (selectedTechRole.id) {
      TechByTechRoleService.getAll(selectedTechRole.id).then((data) => {
        let slice = Math.ceil(data.length / 6);
        setTechByTechRole1(data.slice(0, slice));
        setTechByTechRole2(data.slice(slice, slice * 2));
        setTechByTechRole3(data.slice(slice * 2, slice * 3));
        setTechByTechRole4(data.slice(slice * 3, slice * 4));
        setTechByTechRole5(data.slice(slice * 4, slice * 5));
        setTechByTechRole6(data.slice(slice * 5, data.length - 1));
      });
    }
  }, [selectedTechRole]);

  function getTechRoles() {
    TechRoleService.getAllTechRoles().then((data) => setTechRoles(data));
  }
  return (
    <>
      <div className="row">
        <div className="col">
          <TechByTechRoleHeader
            techRoles={techRoles}
            selectedTechRole={selectedTechRole}
            onChange={onChangeTechrole}
          />{" "}
        </div>
        <div className="col text-end">
          <button className="app-button btn-prime btn-md" onClick={cormfimSave}>
            {t("Save")}
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <TechByTechRoleItemGroup
            itemGroup={techByTechRole1}
            setGroup={setTechByTechRole1}
          />
        </div>
        <div className="col">
          <TechByTechRoleItemGroup
            itemGroup={techByTechRole2}
            setGroup={setTechByTechRole2}
          />
        </div>
        <div className="col">
          <TechByTechRoleItemGroup
            itemGroup={techByTechRole3}
            setGroup={setTechByTechRole3}
          />
        </div>
        <div className="col">
          <TechByTechRoleItemGroup
            itemGroup={techByTechRole4}
            setGroup={setTechByTechRole4}
          />
        </div>
        <div className="col">
          <TechByTechRoleItemGroup
            itemGroup={techByTechRole5}
            setGroup={setTechByTechRole5}
          />
        </div>
        <div className="col">
          <TechByTechRoleItemGroup
            itemGroup={techByTechRole6}
            setGroup={setTechByTechRole6}
          />
        </div>
      </div>
      <ModalContainer
        modalTitle={t("Selected technologies")}
        onClose={() => setSelectedTechByTechRole([])}
        submitButtonAction={submit}
        submitButtonTitle={t("Save")}
        cancelButtonTitle={t("Cancel")}
        cancelButtonAction={() => setSelectedTechByTechRole([])}
        submitButtonType="button"
        isOpen={selectedTechByTechRole.length > 0}
      >
        {selectedTechByTechRole.map((techByTechRole) => (
          <div className="form-check ms-4" key={techByTechRole.id}>
            <input
              className="form-check-input"
              type="checkbox"
              value={techByTechRole.id}
              checked={techByTechRole.selected}
              id={techByTechRole.id}
              name={techByTechRole.id}
              disabled={true}
            />
            <label className="form-check-label" htmlFor={techByTechRole.id}>
              {techByTechRole.description}
            </label>
          </div>
        ))}
      </ModalContainer>
    </>
  );
}
